import React, { useState, useEffect } from "react";
import "../css/login.css";
import classes from "../css/Tabs.module.css";
import { NavLink } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import ReactCustomFlagSelect from "react-custom-flag-select";
import "react-custom-flag-select/lib/react-custom-flag-select.min.css";
import {
  getPacks,
  subscribe,
  getSubStatus,
  sendOtpApi,
  confirmOtpApi,
} from "../../services/auth-api";
import { useTranslation } from "react-i18next";
import { Loader } from "../../utils/loader";
import { flag, countryCode } from "../../utils/constant";
import OtpInput from "react-otp-input";
import Policy from "../../components/policy";

const Register = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState({});
  const [otp, setOtp] = useState("");
  const [checked, setChecked] = useState(true);
  const [login, setLogin] = useState(false);
  const [packs, setPacks] = useState([]); // State to store packs data
  const [pack, setPack] = useState({
    packPrice: 3,
    packCurrency: "MT",
    packFrequency: "Daily",
  }); // State to store packs data
  const [selectedPack, setSelectedPack] = useState(1);
  const [flow, setFlow] = useState(""); // State to track flow
  const [flowMsg, setFlowMsg] = useState({ number: 0, error: true });
  const [message, setMessage] = useState({ message: "", error: true });
  const query = new URLSearchParams(useLocation().search);
  const [language, setLanguage] = useState(
    localStorage.getItem("selectedLanguage") || "3",
  );
  const [ButtonDisabled, setButtonDisabled] = useState(true);
  const subAgain = localStorage.getItem("subAgain") || "0";

  const handlePackSelection = (pack) => {
    setSelectedPack(pack.id);
    setPack(pack);
  };

  useEffect(() => {
    setMessage({ message: "", error: false });
    if (query?.get("nm")) setPhone(query?.get("nm"));

    var userId = null;
    if (query?.get("id")) userId = query?.get("id");
    //console.log("userId "+ userId);
    getPacks(userId)
      .then((res) => {
        //console.log("All packs ", res?.data);
        setPacks(res?.data); // Set packs data
        packs.map((pack) => selectedPack === pack.id && setPack(pack));
        /*if(res?.token)
          {
            localStorage.setItem("token", res.token); 
            window.location.href = localStorage.getItem("menu")?"/"+localStorage.getItem("menu"):"/"
          }*/
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    console.log("language=" + language);
    localStorage.setItem("selectedLanguage", language);
    i18n.changeLanguage(language);
  }, [language]);

  const find = (arr, obj) => {
    return arr.filter((o) => Object.keys(obj).every((i) => obj[i] === o[i]));
  };

  const checkSubStatus = async (input) => {
    console.log("input=" + input);
    setMessage({ message: "", error: false });
    if (phone.length >= 8) {
      setLoading(true);
      await getSubStatus({ mobileNumber: parseInt(phone) })
        .then((res) => {
          setFlow("EXISTING");
          if (res.responseCode === 200) {
            localStorage.setItem("token", res.data.accessToken);
            if (input === "1") {
              window.location.href = "/home";
            } else setFlowMsg({ number: 81, error: false }); //already sub and charged ;
          } else if (res.responseCode === 203)
            setFlowMsg({ number: 100, error: true }); //low balance;
          else if (res.responseCode === 202)
            setFlowMsg({ number: 101, error: true }); //Charging in process;
          else setFlow(""); // select pack
        })
        .catch((err) => {
          console.log(err);
          setMessage({ message: err.message, error: true });
        })
        .finally(() => setLoading(false));
    } else {
      setMessage({ message: t("90"), error: true });
    }
  };

  const handleSubscription = async (subType) => {
    setMessage({ message: "", error: true });
    if (phone && phone.length > 5) {
      setLoading(true);
      await subscribe({
        mobileNumber: phone,
        packId: selectedPack,
        languageId: language,
        subAgain: subAgain,
        type: subType,
      })
        .then((res) => {
          //setFlow("EXISTING");
          //setFlowMsg({number:84,error:false});//New subscription;
          if (localStorage.getItem("subAgain"))
            localStorage.removeItem("subAgain");
          localStorage.setItem("token", res.data.accessToken);
          window.location.href = "/home";
        })
        .catch((err) => {
          console.log(err);
          setMessage({ message: err.message, error: true });
        })
        .finally(() => setLoading(false));
    } else {
      console.log("Please enter number");
    }
  };

  const sendOtp = async () => {
    setMessage({ message: "", error: true });
    if (phone && phone.length > 5) {
      setLoading(true);
      await sendOtpApi({ ani: phone, serviceId: 1, languageId: language })
        .then((res) => {
          if (res.responseCode === 205) {
            setMessage({ message: t("147"), error: true });
          } else setFlow("CONFIRMOTP");
        })
        .catch((err) => {
          console.log(err);
          setMessage({ message: err.message, error: true });
        })
        .finally(() => setLoading(false));
    } else {
      console.log("Please senter number");
    }
  };

  const confirmOtp = async () => {
    setMessage({ message: "", error: true });
    if (phone && phone.length > 5 && otp.length == 4) {
      setLoading(true);
      await confirmOtpApi({
        ani: phone,
        serviceId: 1,
        otp: otp,
        languageId: language,
      })
        .then((res) => {
          if (res.responseCode === 202) {
            if (subAgain && subAgain === "1" && login === false) setFlow("TNC");
            else {
              localStorage.setItem("token", res.data.accessToken);
              window.location.href = "/home";
            }
          } else {
            if (login) setMessage({ message: t("127"), error: true });
            else setFlow("TNC"); //setFlow("PACK");
          }
        })
        .catch((err) => {
          console.log(err);
          setMessage({ message: err.message, error: true });
        })
        .finally(() => setLoading(false));
    } else {
      console.log("Please senter valid detail");
    }
  };

  const handleNumInputsChange = (numInputs) => {
    setOtp(numInputs);
    setButtonDisabled(numInputs.length !== 4 || isNaN(numInputs));
  };

  const handleChange = async (e) => {
    if (e.target.checked) setChecked(true);
    else setChecked(false);
  };
  const redirectToPage = (page) => {
    navigate(page);
  };
  const accessService = async () => {
    window.location.href = localStorage.getItem("menu")
      ? "/" + localStorage.getItem("menu")
      : "/";
  };
  const handleNumberChange = async (event) => {
    const input = event.target.value;
    if (input.length < 10) setPhone(input);
    setButtonDisabled(input.length < 8);
  };

  return (
    <div className="home">
      <div className="maine-div">
        <div className="container-fluid box-wrapper login">
          <div className="header">
            <div className="row align-items-center">
              <div className="col-6 text-start">
                <div className="logo d-flex">
                  <a href="#">
                    <img src="/image/Logo_new.png" alt="Logo" />
                  </a>
                </div>
              </div>

              <div className="col-6 text-end">
                <div className="pt-2">
                  <select
                    className="choose-option"
                    id="dropdown"
                    value={language}
                    onChange={(event) => setLanguage(event.target.value)}
                  >
                    <option className="choose-option" value="0">
                      English
                    </option>
                    <option value="3">Portuguese</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          {flow === "TNC" ? (
            <div className="text-center login-info">
              <h3 className="login-title-red mb-3 mt-3">{t("123")}</h3>
              <div className="scroll">
                <Policy type="reg" />
              </div>
              {message.message && (
                <div className="mb-3">
                  <p
                    className={`alert alert-${message.error ? "danger" : "success"}`}
                  >
                    {message.message}
                  </p>{" "}
                </div>
              )}
              {loading ? (
                <Loader />
              ) : (
                <>
                  <button
                    className="btn btn-primary btn-pm-red"
                    type="button"
                    onClick={() => handleSubscription("CREDIT")}
                  >
                    {t("124")}
                  </button>
                  <button
                    className="btn btn-primary btn-pm-grey"
                    type="button"
                    onClick={() => setFlow("")}
                  >
                    {t("125")}
                  </button>
                </>
              )}
            </div>
          ) : (
            <>
              <div className="login-header pb-4">
                <div className="box-wrapper mx-auto text-center position-relative">
                  <span className="modal-level-title game-title">
                    {t("89")}
                  </span>
                </div>
              </div>
              <div className="login-info">
                <div className="login-thumbnail2">
                  <img src="/image/login_img.png" alt="Quiz" />
                </div>
                <div className={classes.actions_box_container}>
                  <div className={classes.actions_box}>
                    <button
                      className={`${classes.action_box} ${!login && classes.active}`}
                      type="button"
                      onClick={() => {
                        setLogin(false);
                        setFlow("");
                      }}
                    >
                      {t("80")}
                    </button>
                    <button
                      className={`${classes.action_box} ${login && classes.active}`}
                      type="button"
                      onClick={() => {
                        setLogin(true);
                        setFlow("LOGIN");
                      }}
                    >
                      {t("54")}
                    </button>
                  </div>
                </div>
                {/*/<div className="text-center">              
              <h3 className="login-title mb-1 mt-1 text-center">{t("50")}</h3>
              <br/>
              <a className={!login && "lnkBlack lnkSize"} onClick={() => {setLogin(false);setFlow('')}}>{t("80")}</a>
              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              <a className={login && "lnkBlack lnkSize"} onClick={() => {setLogin(true);setFlow('LOGIN')}}>{t("54")} </a> 
              <hr/> <br/>         
            </div> */}
                {flow === "PACK" ? (
                  <div className="pack-main-container">
                    <h3 className="login-title mb-3 mt-3 text-center">
                      {t("79")}
                    </h3>
                    <div className="text-center radio">
                      {packs.map((pack) => (
                        <label key={pack.id} className="pack">
                          <input
                            type="radio"
                            id="rd1"
                            checked={selectedPack === pack.id}
                            onChange={() => handlePackSelection(pack)}
                          />
                          {pack.packPrice +
                            " " +
                            pack.packCurrency +
                            " " +
                            t(pack.packFrequency)}
                        </label>
                      ))}
                    </div>
                    {message.message && (
                      <div className="mb-3">
                        <p
                          className={`alert alert-${message.error ? "danger" : "success"}`}
                        >
                          {" "}
                          {message.message}{" "}
                        </p>
                      </div>
                    )}
                    {loading ? (
                      <Loader />
                    ) : (
                      <>
                        <button
                          className="pack-btn btn btn-primary btn-pm-custom-red"
                          onClick={() => setFlow("CONFIRM")}
                        >
                          {" "}
                          {t("80")}{" "}
                        </button>
                      </>
                    )}
                  </div>
                ) : flow === "EXISTING" ? (
                  <>
                    <h3
                      className={`mb-3 mt-3 text-center login-title-${flowMsg.error ? "red" : "green"}`}
                    >
                      {t(flowMsg.number)}
                    </h3>
                    {loading ? (
                      <Loader />
                    ) : (
                      <button
                        className="pack-btn btn btn-primary btn-pm-custom-red"
                        onClick={() => checkSubStatus("1")}
                      >
                        {" "}
                        {t("83")}
                      </button>
                    )}
                  </>
                ) : flow === "LOGIN" ? (
                  <>
                    <div className="phone-input">
                      <div className="has-validation input-group">
                        <div className="dialing-code">
                          <img
                            src={"https://flagcdn.com/" + flag + ".svg"}
                            width="24"
                            alt="Cameroon"
                          />
                          <span>+{countryCode}</span>
                        </div>
                        <input
                          className="form-control form-mobile-no"
                          type="number"
                          inputMode="numeric"
                          value={
                            phone.length > 9
                              ? phone.substring(phone.length - 9)
                              : phone
                          }
                          onChange={handleNumberChange}
                          placeholder={t("78")}
                        />
                      </div>
                      <br />
                      {message.message && (
                        <div className="mb-3">
                          <p
                            className={`alert alert-${message.error ? "danger" : "success"}`}
                          >
                            {" "}
                            {message.message}{" "}
                          </p>
                        </div>
                      )}
                      {loading ? (
                        <Loader />
                      ) : (
                        <>
                          <button
                            className="pack-btn btn btn-primary btn-pm-custom-red"
                            onClick={sendOtp}
                            disabled={!checked || ButtonDisabled}
                          >
                            {" "}
                            {t("54")}
                          </button>
                        </>
                      )}
                    </div>
                  </>
                ) : flow === "CONFIRM" ? (
                  <div className="text-center">
                    <h3 className="login-title mb-3 mt-3 text-center">
                      {t("111")}{" "}
                      <span className="span-bold">
                        {pack.packCurrency +
                          " " +
                          pack.packPrice +
                          "/" +
                          t(pack.packFrequency) +
                          " " +
                          t("96")}
                      </span>{" "}
                      {t("112")}
                    </h3>
                    <h3 className="login-title mb-3 mt-3 text-center">
                      {t("113")}
                    </h3>
                    {message.message && (
                      <div className="mb-3">
                        <p
                          className={`alert alert-${message.error ? "danger" : "success"}`}
                        >
                          {message.message}
                        </p>{" "}
                      </div>
                    )}
                    {loading ? (
                      <Loader />
                    ) : (
                      <button
                        className="btn btn-primary btn-pm-green"
                        type="button"
                        onClick={() => handleSubscription("CREDIT")}
                      >
                        {t("87")}
                      </button>
                    )}
                    <button
                      className="btn btn-primary btn-pm-red"
                      type="button"
                      onClick={() => setFlow("")}
                    >
                      {t("88")}
                    </button>
                  </div>
                ) : flow === "CONFIRMOTP" ? (
                  <div className="text-center">
                    <h3 className="login-title mb-3 mt-3 text-center">
                      {t("116")}
                    </h3>
                    <h3 className="header mb-3 mt-3 text-center">{t("119")}</h3>
                    <div className="otp_section">
                      <OtpInput
                        value={otp}
                        numInputs={4}
                        renderInput={(props, index) => (
                          <input
                            {...props}
                            type="tel" // Use type="tel" to display the numeric keypad on mobile devices
                            inputMode="numeric" // Specify the numeric input mode
                          />
                        )}
                        inputStyle="form-control form-otp"
                        onChange={handleNumInputsChange}
                      />
                    </div>
                    {message.message && (
                      <div className="mb-3">
                        <p
                          className={`alert alert-${message.error ? "danger" : "success"}`}
                        >
                          {" "}
                          {message.message}{" "}
                        </p>
                      </div>
                    )}
                    {loading ? (
                      <Loader />
                    ) : (
                      <button
                        className="btn btn-primary btn-pm-custom-red"
                        type="button"
                        onClick={confirmOtp}
                        disabled={ButtonDisabled}
                      >
                        {t("120")}
                      </button>
                    )}
                    <div className="resend_otp_main">
                      <NavLink
                        to="javascript:void(0)"
                        className="resend_otp_link"
                        onClick={sendOtp}
                      >
                        {t("56")}
                      </NavLink>
                    </div>
                    <h3 className="header1 mb-1 mt-1 text-center">
                      {t("121")}
                    </h3>
                    <a
                      className="linkBlack linkSize"
                      onClick={() => {
                        redirectToPage("/policy");
                      }}
                    >
                      &nbsp;{t("122")}
                    </a>
                  </div>
                ) : (
                  // New user Flow
                  <>
                    {/*<label>
                  <input value = "test" type = "checkbox" className="customCheckBox" onChange = {handleChange} checked={checked} />
                  <a className="linkBlack" onClick={() => {redirectToPage('/policy')}}>&nbsp;{t("93")}</a>
                  </label>
                  <br/><br/> */}
                    <h3 className="header mb-1 mt-1 text-center">{t("114")}</h3>
                    <div className="text-center radio">
                      {packs.map((pack) => (
                        <>
                          <label key={pack.id} className="pack">
                            <input
                              type="radio"
                              id="rd1"
                              checked={selectedPack === pack.id}
                              onChange={() => handlePackSelection(pack)}
                            />
                            {pack.packPrice +
                              " " +
                              pack.packCurrency +
                              " " +
                              t(pack.packFrequency) +
                              " [" +
                              t("packq" + pack.id) +
                              "]"}
                          </label>{" "}
                          <br />
                        </>
                      ))}
                    </div>
                    <div className="phone-input">
                      <div className="has-validation input-group">
                        <div className="dialing-code">
                          <img
                            src={"https://flagcdn.com/" + flag + ".svg"}
                            width="24"
                            alt="Cameroon"
                          />
                          <span>+{countryCode}</span>
                        </div>
                        <input
                          className="form-control form-mobile-no"
                          type="number"
                          inputMode="numeric"
                          value={
                            phone.length > 9
                              ? phone.substring(phone.length - 9)
                              : phone
                          }
                          onChange={handleNumberChange}
                          placeholder={t("78")}
                        />
                      </div>
                      <br />
                      {message.message && (
                        <div className="mb-3">
                          <p
                            className={`alert alert-${message.error ? "danger" : "success"}`}
                          >
                            {" "}
                            {message.message}{" "}
                          </p>
                        </div>
                      )}
                      {loading ? (
                        <Loader />
                      ) : (
                        <>
                          <button
                            className="pack-btn btn btn-primary btn-pm-custom-green"
                            onClick={sendOtp}
                            disabled={!checked || phone?.length < 8}
                          >
                            {" "}
                            {t("148")}
                          </button>
                          <button
                            className="pack-btn btn btn-primary btn-pm-custom-red"
                            onClick={() => handleSubscription("MPESA")}
                            disabled={!checked || phone?.length < 8}
                          >
                            {" "}
                            {t("149")}
                          </button>
                          <br />
                          <br />
                          <div className="text-center">
                            <h3 className="header1 mb-1 mt-1 text-center">
                              {t("117") +
                                " " +
                                pack.packPrice +
                                " " +
                                pack.packCurrency +
                                " " +
                                t(pack.packFrequency) +
                                " " +
                                t("118")}
                            </h3>
                            <a
                              className="linkBlack linkSize"
                              onClick={() => {
                                redirectToPage("/terms");
                              }}
                            >
                              &nbsp;{t("122")}
                            </a>
                          </div>
                        </>
                      )}
                    </div>
                  </>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Register;
